let lenis = null;

export const setLenis = (instance) => {
    lenis = instance;
};

export const scrollToSection = (hash) => {
    if (lenis) {
        lenis.scrollTo(hash, { offset: -72, duration: 1.4 });
    } else {
        document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
    }
};
